import React, { useContext, useState } from "react";
import {
  ArrowRightOnRectangleIcon,
  Bars3Icon,
} from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import PrimaryButton from "../Button/PrimaryButton";
import { AuthContext } from "../../contexts/AuthProvider";
import UserMenu from "./UserMenu";
import AdminMenu from "./AdminMenu";
import HostMenu from "./HostMenu";
import "./Sidebar.css";
import AdminMenuDynamic from "./AdminMenuDynamic";

const Sidebar = ({ role, loading }) => {
  const { user, logout } = useContext(AuthContext);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="relative min-h-screen flex">
  {/* Mobile Overlay */}
  <div
    className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300 lg:hidden ${
      isSidebarOpen ? "opacity-100 visible" : "opacity-0 invisible"
    }`}
    onClick={toggleSidebar}
  ></div>

  {/* Main Sidebar */}
  <aside
    className={`fixed inset-y-0 left-0 z-50 flex flex-col w-72 bg-slate-900 border-r border-white/10 transition-transform duration-300 transform lg:translate-x-0 lg:static lg:inset-0 ${
      isSidebarOpen ? "translate-x-0" : "-translate-x-full"
    }`}
  >
    {/* Brand Header */}
    <div className="h-20 flex items-center px-6 border-b border-white/5">
      <a href="https://www.mycolorevent.com/" target="_blank" className="flex items-center gap-3 group">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-blue-500/20 group-hover:scale-110 transition-transform">
          <span className="text-white font-black text-xl">M</span>
        </div>
        <h1 className="text-lg font-bold tracking-tight text-white uppercase font-roboto">
          My Color <span className="text-blue-500">Events</span>
        </h1>
      </a>
    </div>

    {/* Admin Profile Quick View */}
    <div className="px-6 py-4">
      <div className="p-3 rounded-xl bg-white/5 border border-white/5">
        <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">{role} Account</p>
        <p className="text-sm text-gray-200 truncate mt-1">{user?.email}</p>
      </div>
    </div>

    {/* Navigation Area */}
    <div className="flex-1 px-4 py-4 space-y-1 overflow-y-auto custom-scrollbar">
      <nav>
        {role === "admin" ? <AdminMenuDynamic /> : <HostMenu />}
      </nav>
    </div>

    {/* Bottom Actions */}
    <div className="p-4 border-t border-white/5 space-y-2">
      <button
        onClick={logout}
        className="flex items-center w-full px-4 py-3 text-gray-400 hover:text-white hover:bg-red-500/10 rounded-xl transition-all group"
      >
        <ArrowRightOnRectangleIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        <span className="ml-3 font-semibold text-sm">Sign Out</span>
      </button>
    </div>
  </aside>
</div>
  );
};

export default Sidebar;
